import React from 'react';
import { addToPriorityQueue } from '../../utils/api';
import { KPICard, Button } from '../ui';

function ManagerFinanceTab({ unitId, onAddToQueue }) {
  const handleAddToQueue = async (payload) => {
    try {
      await addToPriorityQueue({
        title: payload.title,
        description: payload.metric || '',
        category: 'Finance',
        priority: payload.priority || 'medium',
        estimatedTime: 45,
        dueDate: new Date().toISOString(),
        type: 'task',
        ...payload
      });
      onAddToQueue && onAddToQueue();
    } catch (err) {
      console.error('Add to queue failed:', err);
    }
  };

  return (
    <div className="dashboard-container">
      {/* Labor Costs Overview */}
      <div className="section-header">
        <h2 className="section-title">Labor Costs Overview</h2>
        <p className="section-subtitle">Practice-level financial performance</p>
      </div>

      <div className="grid grid-cols-2 xl:grid-cols-4 gap-5">
        <KPICard
          size="md"
          label="Labor Cost"
          value="$1.2M"
          domain="finance"
          trend="2.1% vs last month"
          trendDown={false}
          action={<Button variant="default" size="sm" type="button" onClick={() => handleAddToQueue({ type: 'finance', title: 'Review labor cost trends', metric: 'Labor Cost' })}>Add to Queue</Button>}
        />

        <KPICard
          size="md"
          label="Overtime"
          value="$42K"
          domain="finance"
          alertLevel="warning"
          trend="8.5% vs last month"
          trendDown={true}
          action={<Button variant="default" size="sm" type="button" onClick={() => handleAddToQueue({ type: 'finance', title: 'Address overtime spend', metric: 'Overtime', priority: 'high' })}>Add to Queue</Button>}
        />

        <KPICard
          size="md"
          label="Cost per Visit"
          value="$156"
          domain="finance"
          subLabel="On target"
          action={<Button variant="default" size="sm" type="button" onClick={() => handleAddToQueue({ type: 'finance', title: 'Monitor cost per visit trends', metric: 'Cost per Visit' })}>Add to Queue</Button>}
        />

        <KPICard
          size="md"
          label="Variance to Budget"
          value="-$28K"
          domain="finance"
          alertLevel="critical"
          subLabel="Over budget"
          action={<Button variant="default" size="sm" type="button" onClick={() => handleAddToQueue({ type: 'finance', title: 'Address budget variance', metric: 'Variance to Budget', priority: 'high' })}>Add to Queue</Button>}
        />
      </div>

      {/* Labor Breakdown */}
      <div className="section-header" style={{ marginTop: '40px' }}>
        <h3 className="section-title">Labor Cost Breakdown</h3>
      </div>

      <div className="grid grid-cols-2 gap-5">
        <div className="bg-nn-white rounded-[14px] shadow-card overflow-hidden hover:shadow-md transition-shadow relative">
          <div className="px-5 py-4 flex justify-between items-center">
            <div className="font-heading text-body font-semibold text-text-dark">Regular Hours</div>
          </div>
          <div className="p-5">
            <div className="flex justify-between items-center mb-3 pb-3 border-b border-nn-border last:border-b-0 last:mb-0 last:pb-0">
              <span className="text-body-sm text-text-muted">Total Hours</span>
              <span className="text-xl font-bold text-text-dark">8,240</span>
            </div>
            <div className="flex justify-between items-center mb-3 pb-3 border-b border-nn-border last:border-b-0 last:mb-0 last:pb-0">
              <span className="text-body-sm text-text-muted">Cost</span>
              <span className="text-base font-semibold text-text-dark">$1.16M</span>
            </div>
            <div className="flex flex-wrap gap-2 mt-4 pt-4 border-t border-nn-border">
              <Button variant="default" size="sm" type="button"
                onClick={() => handleAddToQueue({ type: 'finance', title: 'Review regular hours utilization', metric: 'Regular Hours' })}>
                Add to Queue
              </Button>
            </div>
          </div>
        </div>

        <div className="bg-nn-white rounded-[14px] shadow-card overflow-hidden hover:shadow-md transition-shadow relative">
          <div className="px-5 py-4 flex justify-between items-center">
            <div className="font-heading text-body font-semibold text-text-dark">Overtime Hours</div>
          </div>
          <div className="p-5">
            <div className="flex justify-between items-center mb-3 pb-3 border-b border-nn-border last:border-b-0 last:mb-0 last:pb-0">
              <span className="text-body-sm text-text-muted">Total OT Hours</span>
              <span className="text-xl font-bold text-text-dark">320</span>
            </div>
            <div className="flex justify-between items-center mb-3 pb-3 border-b border-nn-border last:border-b-0 last:mb-0 last:pb-0">
              <span className="text-body-sm text-text-muted">Cost</span>
              <span className="text-base font-semibold text-red-critical">$42K</span>
            </div>
            <div className="flex flex-wrap gap-2 mt-4 pt-4 border-t border-nn-border">
              <Button variant="default" size="sm" type="button"
                onClick={() => handleAddToQueue({ type: 'finance', title: 'Address overtime trends', metric: 'Overtime Hours', priority: 'high' })}>
                Add to Queue
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ManagerFinanceTab;
